import { SWReactIcons } from "@similarweb/icons";
import { PixelPlaceholderLoader, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { WIDTH, HEIGHT } from "./constants";
import * as SC from "./styles";
import type { FileInputSchema } from "./type";

export const FileInput = ({ text, tooltip, color, isLoading, onClick }: FileInputSchema) =>
    isLoading ? (
        <PixelPlaceholderLoader
            width={WIDTH}
            height={HEIGHT}
        />
    ) : (
        <PlainTooltip
            enabled
            tooltipContent={translate(tooltip)}
        >
            <SC.InputWrapper>
                <SWReactIcons
                    iconName="upload"
                    size="xs"
                    iconColor={color}
                />
                <div>{translate(text)}</div>
                <SC.FileInput
                    title=""
                    onChange={onClick}
                    accept=".csv"
                    type="file"
                />
            </SC.InputWrapper>
        </PlainTooltip>
    );
